module.exports = __webpack_public_path__ + "static/media/down-arrow.b7b8f0ec.svg";